import routerOptions0 from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}